import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/erp/gen-doc/internal-purchase-orders/print-jasper-pdf/

@Injectable({ providedIn: "root" })
export class MultiPOJasperPDFService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX;
    this.httpClient = http;
  }
  printJasperPdf(
    gendocGuid: any,
    printableGuid: any,
    visa: ApiVisa
  ): Observable<Blob> {

    this.apiUrl = visa.api_domain_url + this.endpoint_path + "internal-purchase-orders/print-jasper-pdf/" +
                  gendocGuid + "?printServiceClassName=INTERNAL_PURCHASE_ORDER_PRINT_SERVICE&printableFormatHdrGuid=" + printableGuid

    return this.httpClient.get<Blob>(
      this.apiUrl,
      this.getHttpHeaderBlob(visa)
    );
  }
}
